import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  return <footer className="py-8 px-6 bg-[#09090b] border-t border-zinc-900" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        {/* Terms toggle */}
        <div className="mb-6" data-id="element-159">
          <button onClick={() => setShowTerms(!showTerms)} className="mx-auto flex items-center gap-1.5 text-zinc-500 hover:text-zinc-300 text-sm transition-colors" data-id="element-160">
            Términos y Condiciones
            <ChevronDownIcon className={`w-4 h-4 transition-transform duration-300 ${showTerms ? 'rotate-180' : ''}`} data-id="element-161" />
          </button>

          <AnimatePresence data-id="element-162">
            {showTerms && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-163">
                <div className="mt-6 bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 sm:p-8 text-left text-sm text-zinc-400 leading-relaxed space-y-4 max-h-[60vh] overflow-y-auto" data-id="element-164">
                  <h3 className="text-white font-semibold text-base mb-4" data-id="element-165">
                    Términos y Condiciones
                  </h3>

                  <p data-id="element-166">
                    Al adquirir el Protocolo Dopamina Cero (en adelante, "el
                    Producto"), aceptas los siguientes términos y condiciones de
                    uso. Te recomendamos leerlos detenidamente antes de realizar
                    tu compra.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-167">
                    1. Naturaleza del Producto
                  </h4>
                  <p data-id="element-168">
                    El Producto es un recurso educativo en formato digital (PDF)
                    diseñado con fines informativos y de desarrollo personal. No
                    constituye asesoramiento médico, psicológico ni profesional
                    de ningún tipo. Si padeces una condición médica o
                    psicológica, consulta a un profesional de la salud antes de
                    aplicar cualquier protocolo.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-169">
                    2. Entrega y Acceso
                  </h4>
                  <p data-id="element-170">
                    Tras completar el pago, recibirás acceso inmediato al
                    Producto a través de un enlace de descarga. Es tu
                    responsabilidad guardar y respaldar el archivo. No nos
                    hacemos responsables de la pérdida del archivo una vez
                    descargado.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-171">
                    3. Política de Reembolso
                  </h4>
                  <p data-id="element-172">
                    Debido a la naturaleza digital e inmediata del Producto,
                    todas las ventas son finales. No se ofrecen reembolsos una
                    vez que se ha proporcionado el acceso al contenido.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-173">
                    4. Propiedad Intelectual
                  </h4>
                  <p data-id="element-174">
                    Todo el contenido del Producto, incluyendo textos, gráficos,
                    diseños y metodologías, está protegido por derechos de
                    autor. Queda prohibida su reproducción, distribución,
                    modificación o reventa total o parcial sin autorización
                    expresa por escrito.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-175">
                    5. Limitación de Responsabilidad
                  </h4>
                  <p data-id="element-176">
                    Los resultados pueden variar de persona a persona. No
                    garantizamos resultados específicos derivados del uso del
                    Producto. El usuario asume toda la responsabilidad por las
                    decisiones y acciones tomadas a partir de la información
                    proporcionada.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-177">
                    6. Uso Aceptable
                  </h4>
                  <p data-id="element-178">
                    El Producto es para uso personal y exclusivo del comprador.
                    No está permitido compartir, redistribuir ni publicar el
                    contenido en ninguna plataforma pública o privada sin
                    autorización previa.
                  </p>

                  <h4 className="text-zinc-300 font-semibold mt-4" data-id="element-179">
                    7. Modificaciones
                  </h4>
                  <p data-id="element-180">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Las modificaciones serán efectivas desde
                    su publicación en esta página. El uso continuado del
                    Producto tras dichas modificaciones constituye la aceptación
                    de los nuevos términos.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        {/* Copyright */}
        <div className="text-center" data-id="element-181">
          <p className="text-zinc-500 text-sm" data-id="element-182">
            &copy; {new Date().getFullYear()} Protocolo Dopamina Cero. Todos los
            derechos reservados.
          </p>
          <p className="text-zinc-600 text-xs mt-2 max-w-xl mx-auto" data-id="element-183">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}